const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 6.5,
    r: 5.5,
    fill: "#84A6B9",
    style: {
      fill: "#84A6B9",
      fill: "color(display-p3 0.5176 0.6510 0.7255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77051 6.81331C4.92029 7.01355 5.11138 7.17924 5.33083 7.29913C5.55027 7.41902 5.79293 7.49032 6.04236 7.50818C6.29178 7.52604 6.54212 7.49006 6.77641 7.40266C7.0107 7.31526 7.22346 7.1785 7.40024 7.00165L8.44656 5.95533C8.76422 5.62644 8.93999 5.18594 8.93601 4.7287C8.93204 4.27147 8.74864 3.83409 8.42532 3.51076C8.10199 3.18744 7.66461 3.00404 7.20738 3.00007C6.75014 2.99609 6.30964 3.17186 5.98074 3.48952L5.38086 4.08592",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16557 6.11534C6.01579 5.9151 5.8247 5.74941 5.60525 5.62952C5.38581 5.50963 5.14315 5.43833 4.89372 5.42047C4.6443 5.40261 4.39396 5.4386 4.15967 5.52599C3.92538 5.61339 3.71262 5.75015 3.53584 5.927L2.48952 6.97332C2.17186 7.30221 1.99609 7.74271 2.00007 8.19995C2.00404 8.65718 2.18744 9.09456 2.51076 9.41789C2.83409 9.74121 3.27147 9.92461 3.7287 9.92859C4.18594 9.93256 4.62644 9.75679 4.95533 9.43913L5.55173 8.84273",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.beb8ec491ac823f6ba8024adeda807e5.svg";
export { ForwardRef as ReactComponent };